module.exports = __webpack_public_path__ + "img/goals.fab830d.svg";